import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
const REIKI_SYMBOLS = ['M12 2v16c0 2 2 3 4 3s4-1 4-3-2-3-4-3-4 1-4 3c0 1 .5 2 1.5 2.5M12 6c-3 0-5 2-5 4s2 4 5 4 5-2 5-4-2-4-5-4z', 'M7 4c0 4 2 6 5 6s5-2 5-6M12 10v10M9 14h6M5 8h14', 'M12 3v18M8 7h8M7 11h10M9 15h6M10 19h4', 'M12 2L4 10h16L12 2zM12 10v12M8 14h8M6 18h12'];
export function HeroReikiIcons() {
  const icons = useMemo(() => {
    return Array.from({
      length: 8
    }).map((_, i) => ({
      id: i,
      path: REIKI_SYMBOLS[i % REIKI_SYMBOLS.length],
      top: `${Math.random() * 80 + 10}%`,
      left: `${Math.random() * 80 + 10}%`,
      size: Math.random() * 60 + 40,
      duration: Math.random() * 10 + 10,
      delay: Math.random() * 5,
      opacity: Math.random() * 0.1 + 0.05
    }));
  }, []);
  return <div className="absolute inset-0 pointer-events-none overflow-hidden z-0" data-id="element-187">
      {icons.map(icon => <motion.svg key={icon.id} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round" className="text-white" style={{
      position: 'absolute',
      top: icon.top,
      left: icon.left,
      width: icon.size,
      height: icon.size,
      opacity: icon.opacity
    }} animate={{
      y: [0, -20, 0],
      x: [0, 10, 0],
      rotate: [0, 10, -10, 0],
      scale: [1, 1.1, 1]
    }} transition={{
      duration: icon.duration,
      repeat: Infinity,
      delay: icon.delay,
      ease: 'easeInOut'
    }} data-id="element-188">
          <path d={icon.path} data-id="element-189" />
        </motion.svg>)}
    </div>;
}